var _ = require('lodash');
var React = require('react');
var Reflux = require('reflux');

var Slider = require('bootstrap-slider');

var analytics = require('analytics');
var storyScenarios = require('models/storyScenarios');

var ChartStore = require('stores/ChartStore');
var ScrollSpyContentsMixin = require('views/scrollSpy/ScrollSpyContentsMixin');

var SCROLLSPY_PROPS = {
  id: 'scenario-liquidation-preferences-exit',
  name: 'Liquidation Preferences and Exits'
}

module.exports = React.createClass({displayName: "module.exports",
  mixins: [
    ScrollSpyContentsMixin,
    Reflux.listenTo(actions.exit.changeValuation, '_onChangeExitValuation')
  ],

  getInitialState:function() {
    return {
      scrollSpy: SCROLLSPY_PROPS
    };
  },

  _onChangeExitValuation: function(exit, value) {
    if (exit !== storyScenarios.rounds.exit)
      return; // then we don't care about it

    this.setState({
      sliderValue: value
    });
  },

  componentDidMount: function() {
    this._origExitValuation = storyScenarios.rounds.exit.valuation;

    var slideStartMs;
    var slideStartValue;

    this._slider = new Slider( React.findDOMNode(this.refs.roundSlider), {
      enabled: this.state.sliderEnabled,
      value: this.state.sliderValue,
      min: 10000000,
      max: 50000000,
      step: 100000,
      formatter: ChartStore.CURRENCY_FORMATTER
    })
    .on('change', this._onSliderChange)
    .on('slideStart', function(value) {
      slideStartMs = Date.now();
      slideStartValue = value;
    })
    .on('slideStop', function(slideEndValue) {
      analytics.event(
        analytics.E.SLIDER.ID,
        analytics.E.SLIDER.SLIDE_STOP,
        SCROLLSPY_PROPS.id,
        Date.now() - slideStartMs,
        {
          startValue: slideStartValue,
          endValue: slideEndValue
        }
      );
    });
  },

  onScrollSpyFocus: function(target) {
    this.setState({
      sliderEnabled: true
    });

    actions.ui.hideSelectRound(false);
    actions.ui.showPVScatter(true);
    actions.chart.setAxisLock();
    actions.chart.selectMeasure('values');
    actions.exit.changeValuation(storyScenarios.rounds.exit, 33000000);
    actions.round.setScenario(storyScenarios.rounds.exit);
  },

  _onSliderChange: function(sliderVals) {
    actions.exit.changeValuation(storyScenarios.rounds.exit, sliderVals.newValue, {throttle: true});
    actions.chart.selectRound(storyScenarios.rounds.exit);
  },

  onScrollSpyUnfocus: function(target) {
    this.setState({
      sliderEnabled: false
    });
  },

  render:function() {
    if (this._slider) {

      if (this.state.sliderEnabled) {
        this._slider.setValue( this.state.sliderValue, false, false );
        this._slider.enable();
      } else {
        this._slider.disable();
      }
    }

    return (
      React.createElement("div", {id: SCROLLSPY_PROPS.id}, 
        React.createElement("h2", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Liquidation Preferences and the Empty-Handed Exit"), 
        React.createElement("p", null, 
          "But not all exits work out so well."
        ), 
        React.createElement("p", null, 
          "When a new financing round brings new investors onboard, they often come onboard with" + " " +
          "a ", React.createElement("strong", null, "\"Last-In-First-Out\""), " investment model — if" + " " +
          "the exit does not produce enough money to match the investments put in, the last investors in get their" + " " +
          "investment returned before anyone else gets anything.  The mechanism for this is called ", React.createElement("strong", null, "liquidation" + " " +
          "preferences"), "."
        ), 
        React.createElement("p", null, 
          "Later rounds tend to require higher amounts of capital with even higher exit growth needed to produce a return" + " " +
          "on that capital. By giving later investors the right to exit first, they may be able to get a return even if" + " " +
          "that higher growth does not materialize.  ", React.createElement("strong", null, "Thus, liquidation preferences reduce risk for later" + " " +
          "investors"), ", helping to get on board.  However, this comes at the expense of earlier investors and" + " " +
          "common-stock holders, who now ", React.createElement("em", null, "require"), " the larger exit growth in order to get any return."
        ), 
        React.createElement("div", {className: "panel panel-info side-note"}, 
          React.createElement("div", {className: "panel-body"}, 
            "Liquidation preferences can also come with multipliers.  A late-round investor with a 2x liquidation" + " " +
            "preference will get twice his investment out before other shareholders get anything.  This further reduces" + " " +
            "risk for later investors by guarenteeing them a profit (if there is a profit to be had by anyone)."
          )
        ), 
        React.createElement("p", null, 
          "If you're near the back, your shares may even be ", React.createElement("strong", null, "underwater"), " — they may be worth less than" + " " +
          "the initial investment that created them."
        ), 
        React.createElement("p", null, 
          "If you're at the very back (such as founder and employee ", React.createElement("strong", null, "common stock"), " versus the" + " " +
          "investors' ", React.createElement("strong", null, "preferred stock"), "), you may even walk away with nothing if there's not" + " " +
          "enough to satisfy the claims in front of you."
        ), 

        React.createElement("div", {className: "panel panel-info"}, 
          React.createElement("div", {className: "panel-heading"}, 
            React.createElement("i", {className: "fa fa-hand-o-right"}), " The Liquidation Preference"
          ), 
          React.createElement("div", {className: "panel-body"}, 
            React.createElement("p", null, 
              "Today is not a good day.  Adjust the exit valuation and note the order in which the exit's returns flow" + " " +
              "to different investors using the table on the right."
            ), 

            React.createElement("div", {className: "visible-xs-block alert alert-danger"}, 
              React.createElement("strong", null, "Wider is Better"), 
              React.createElement("p", null, 
                "View this on a wider screen for a detailed cap table showing each investor's exit share!"
              )
            ), 

            React.createElement("p", null, 
              "If the future outlook of you venture is uncertain, which investors might push the company to take this" + " " +
              "exit opportunity today, and which investors might push to wait for another day? Scenarios like these are" + " " +
              "when board voting preferences become important."
            ), 
            React.createElement("div", null, 
              "Exit valuation: ", React.createElement("span", {ref: "roundSlider"}), React.createElement("br", null)
            )
          )
        )
      )
    );
  }
});


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jsx-loader?harmony!./views/scrollSpyContents/LiquidationPreferencesExit.jsx
 **/